export { HotelsCarousel } from "./HotelsCarousel";